import React from 'react';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import Loading from '@pb/kit-component-loading';

import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';
import type {ServerResponse} from 'src/typedef';

type Props = {
    id: string,
    busy: boolean,
    response: ServerResponse<Array<UserShortInfo>> | null,
};

export const TemplateUserList = ({id, busy, response}: Props) => {
    if (busy) {
        return (
            <div id={id} className="pd-s">
                <div><Loading type="ICON"/> Loading</div>
            </div>
        );
    }

    if (response?.data?.length) {
        return (
            <div id={id}>
                {response.data.map(user => (
                    <AutosuggestItem
                        key={user.userId}
                        value={user}
                        caption={(
                            <div style={{alignItems: 'center', display: 'flex', gap: 8}}>
                                <div style={{width: 180}}>
                                    {user.email ? (
                                        <EllipsisTextHint title={user.email}>
                                            {user.email}
                                        </EllipsisTextHint>
                                    ) : null}
                                </div>
                                <div style={{width: 80}}>
                                    {[user.firstName, user.lastName].filter(Boolean).join(' ') ? (
                                        <EllipsisTextHint
                                            mix="disabled"
                                            title={[user.firstName, user.lastName].filter(Boolean).join(' ')}>
                                            {[user.firstName, user.lastName].filter(Boolean).join(' ')}
                                        </EllipsisTextHint>
                                    ) : null}
                                </div>
                            </div>
                        )}
                    />
                ))}
            </div>
        );
    }

    if (response?.data && !response.data.length) {
        return (
            <div id={id} className="pd-s">
                No accounts found
            </div>
        );
    }

    if (response?.error) {
        return (
            <div id={id} className="pd-s">
                {response.error.message}
            </div>
        );
    }

    return null;
};
